// generate a profile api client
// Path: src/helpers/api/profile.ts
import apiClient from './client'
export const tag = {
    getPosts: (query: any) =>
        apiClient.get('reveries/feed', { params: { ...query } }),
    getFollowings: (query: any) =>
        apiClient.get('friends/matches', { params: { ...query } }),
}
